import React from 'react';

type Props = {
  className?: string;
};

const VisaIcon: React.FC<Props> = ({ className }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 68 22" className={className}>
    <path
      fill="#1434CB"
      d="M25.463.586l-8.77 20.882h-5.72L6.656 4.804C6.395 3.777 6.167 3.4 5.37 2.969 4.07 2.264 1.921 1.603.031 1.193L.16.586h9.209c1.174 0 2.23.78 2.496 2.13l2.279 12.083L19.776.586h5.687zm22.416 14.065c.023-5.512-7.636-5.815-7.583-8.277.017-.75.731-1.546 2.296-1.75.775-.101 2.912-.178 5.336.935l.95-4.428C47.576.659 45.9.205 43.816.205c-5.35 0-9.115 2.838-9.147 6.902-.034 3.007 2.688 4.684 4.738 5.683 2.11 1.023 2.818 1.68 2.81 2.596-.015 1.4-1.683 2.019-3.241 2.043-2.72.042-4.3-.735-5.557-1.319l-.981 4.575c1.264.58 3.598 1.085 6.018 1.11 5.686 0 9.406-2.803 9.423-7.144zm14.127 6.817h5.005L62.641.586h-4.62a2.463 2.463 0 00-2.303 1.532l-8.121 19.35h5.683l1.128-3.119h6.944l.654 3.12zm-6.04-7.399l2.85-7.84 1.639 7.84h-4.488zM33.197.586L28.72 21.468h-5.412L27.785.586h5.41z"
    ></path>
  </svg>
);

export default VisaIcon;
